import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdminPanelRouting } from './admin-panel.routing';
import { AdminGamesService, AdminUsersFiltersStorage, GeneratePostService, UsersListService } from '@admin-panel/infra';

@NgModule({
  imports: [RouterModule.forChild(AdminPanelRouting)],
  providers: [UsersListService, GeneratePostService, AdminGamesService, AdminUsersFiltersStorage]
})
export class AdminPanelModule {}
